var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory182(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 165,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 366,
    width: 357,
    height: 165
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 366,
    width: 357,
    height: 165
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-293 -366)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.447 528 348.515 504.363C328.108 502.513 292.226 502.332 294.068 469.861 295.748 440.42 330.908 444.955 356.894 448.818L549 480.999 539.447 528Z",
    fill: "#3B88C3",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 481.093 473.195 468.131C464.326 466.538 456.426 479.714 456.031 493.661 455.582 509.166 460.106 517.007 469.066 518.833L543.47 528 549 481.093Z",
    fill: "#88C9F9",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.401 475.328 582.904 519 498 426.674 545.497 383.001C570.151 360.323 608.88 361.953 631.56 386.606L634.005 389.269C656.667 413.94 655.055 452.649 630.401 475.328Z",
    fill: "#3B88C3",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.333 439.107C600.685 464.505 603.142 500.24 582.821 518.924 562.5 537.609 527.096 532.166 503.744 506.769 480.392 481.371 477.935 445.635 498.256 426.951 518.577 408.267 553.981 413.709 577.333 439.107Z",
    fill: "#88C9F9",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.936 456.023C572.946 471.26 576.066 491.185 565.905 500.527 555.745 509.869 536.151 505.09 522.141 489.853 508.131 474.616 505.011 454.691 515.172 445.349 525.332 436.006 544.926 440.785 558.936 456.023Z",
    fill: "#226699",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory182);
export default __webpack_public_path__ + "static/media/accessory18-2.b6bf956b8dfdbcea044641a42785c467.svg";
export { ForwardRef as ReactComponent };